import { api } from "./api";

export const settingData = async () => {
  return await api.get(`/settings`);
};

export const settingUpdate = async (data) => {
  return await api.post("/setting/update", data);
};

export const razorpaySettingUpdate = async (data) => {
  return await api.post("/razorpay/settings/update", data);
};
